import React from "react";
import styles from "../DressingChangeFrequency.module.scss";

interface SummaryBoxProps {
  summaryText: string;
  nextText: string;
}

export const SummaryBox: React.FC<SummaryBoxProps> = ({ summaryText, nextText }) => (
  <div className={styles.summary_box}>
    <span className={styles.summary_label}>Reads as</span>
    <span className={styles.summary_text}>{summaryText}</span>
    {nextText && <span className={styles.summary_next}>{nextText}</span>}
  </div>
);
